import React from "react";
import { Button, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import Flatpickr from "react-flatpickr";

type DueDateModalProps = {
  isOpen: boolean;
  dueDate: Date;
  creditTerms: number[];
  onClose: () => void;
  onSelectTerm: (days: number) => void;
  onDateChange: (date: Date) => void;
};

const DueDateModal: React.FC<DueDateModalProps> = ({
  isOpen,
  dueDate,
  creditTerms,
  onClose,
  onSelectTerm,
  onDateChange,
}) => (
  <Modal isOpen={isOpen} toggle={onClose} size="md">
    <ModalHeader toggle={onClose}>Vencimiento de crédito</ModalHeader>
    <ModalBody>
      <p className="mb-2">Seleccioná un plazo rápido o elegí una fecha personalizada.</p>
      <div className="d-flex flex-wrap gap-2 mb-3">
        {creditTerms.map((days) => (
          <Button
            key={days}
            color="outline-secondary"
            size="sm"
            onClick={() => onSelectTerm(days)}
          >
            +{days} días
          </Button>
        ))}
      </div>
      <Label className="form-label">Fecha de vencimiento</Label>
      <Flatpickr
        className="form-control mb-3"
        value={dueDate}
        onChange={(selected) => {
          if (selected[0]) {
            onDateChange(selected[0]);
          }
        }}
      />
      <div className="text-end">
        <Button color="primary" size="sm" onClick={onClose}>
          Confirmar
        </Button>
      </div>
    </ModalBody>
  </Modal>
);

export default DueDateModal;
